import React, {useState} from "react";
import {InputNumber} from "antd";
import {useTranslation} from "react-i18next";
import {numericInputProps} from "utils/helpers";
import {
    SelectionCard,
    SelectionHeader,
    SelectionTitle,
    CourierCountContainer,
    SelectionInfo
} from "../style/CustomerRequestsPage.styles";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {VText} from "components/_defaultComponents/Text/VText";

const CourierCountInput = ({courierCount, setCourierCount, isActive, isSupportRequest = false}) => {
    const {t} = useTranslation();
    const [courierError, setCourierError] = useState("");

    const handleCourierChange = value => {
        setCourierCount(value);
        if (isSupportRequest) {
            if (value !== null && value !== undefined && value < 1) {
                setCourierError(t("screens.customerRequests.pleaseEnterValidCourierCount"));
            } else {
                setCourierError("");
            }
        } else {
            // Kurye planlama talebi için kurye sayısı 1-10 arasında olmalıdır
            if (value !== null && value !== undefined && (value < 1 || value > 10)) {
                setCourierError(t("screens.customerRequests.courierCountMustBeBetween1And10"));
            } else {
                setCourierError("");
            }
        }
    };

    return (
        <SelectionCard $disabled={!isActive}>
            <SelectionHeader>
                <SelectionTitle>3. {t("screens.customerRequests.courierCount")}</SelectionTitle>
            </SelectionHeader>
            <CourierCountContainer>
                <label style={{fontWeight: 500, fontSize: "14px"}}>
                    {t("screens.customerRequests.requestedCourierCount")}
                </label>
                <VFlex vertical>
                    <InputNumber
                        value={courierCount}
                        onChange={handleCourierChange}
                        placeholder={t("screens.customerRequests.enterCount")}
                        style={{width: "100px", marginLeft: "12px"}}
                        disabled={!isActive}
                        min={0}
                        {...numericInputProps}
                    />
                    {courierError && (
                        <VText
                            style={{
                                color: "#ff4d4f",
                                fontSize: "12px",
                                marginTop: "4px",
                                marginLeft: "12px"
                            }}
                        >
                            {courierError}
                        </VText>
                    )}
                </VFlex>
            </CourierCountContainer>
        </SelectionCard>
    );
};

export default CourierCountInput;
